import { GALLERY_IMAGES, GALLERY_FILTERS } from "../data/business";
import { SectionHeading } from "../components/SectionHeading";
import { GalleryGrid } from "../components/GalleryGrid";
import { CTASection } from "../components/CTASection";
import { useSEO } from "../hooks/useSEO";

export default function Gallery() {
  useSEO(
    "Gallery | New Lookz Hair Salon — Gandhi Nagar, Hyderabad",
    "Browse haircut, styling and grooming inspiration from New Lookz Hair Salon in Gandhi Nagar, Hyderabad.",
    "/gallery"
  );

  return (
    <>
      <section className="bg-ink grain" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <SectionHeading
            dark
            eyebrow="Gallery"
            title="Find Your Next Look"
            text="Editorial inspiration across cuts, styling and grooming. Stock placeholder photography — real salon photos coming soon."
          />
        </div>
      </section>
      <section className="bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <GalleryGrid images={GALLERY_IMAGES} filters={GALLERY_FILTERS} />
        </div>
      </section>
      <CTASection />
    </>
  );
}
